import cleanedFilename from '~/util/cleanedFilename';

export default {
  CONTAINER: `${cleanedFilename(__filename)}-container`,
  PDF_LINK_PROCESSING: `${cleanedFilename(__filename)}-pdf-processing-link`,
  PDF_LINK: `${cleanedFilename(__filename)}-pdf-link`,
};
